<template>
    <h1>This is the Search Result PQ Page</h1>
</template>

<script>
export default {
    name: 'SearchResultPQ',
};
</script>
